<div class="d-flex align-items-center flex-wrap header-container">
  <div class="asset-header-back-button col-auto">
    <button class="action-button" (click)="handleBackButtonClicked()">
      <svg
        width="15"
        height="12"
        viewBox="0 0 15 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.71 1.28906L1 5.99906L5.71 10.7091M1.5652 5.99906H13.4344"
          stroke="#17171A"
          stroke-opacity="0.9"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </button>
  </div>

  <div class="text-div">
    <h5 class="title">{{ title | translate }}</h5>
    <p class="subtitle text-muted">
      {{ utilityName || ("HEADER_BREADCRUMB.NEW_UTILITY" | translate) }}
    </p>
  </div>
</div>
